import { Box, Button, Container, Heading, Stack, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Dashboard from '../Dashboard'

const Home = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return <Dashboard />
  }

  return (
    <Container maxW="container.xl" py={20}>
      <Stack spacing={8} alignItems="center" textAlign="center">
        <Heading size="2xl">Welcome to Chrysalis</Heading>
        <Text fontSize="xl">
          Your intelligent platform for cryptocurrency market analysis and trading insights
        </Text>
        <Box>
          <Button
            colorScheme="blue"
            size="lg"
            onClick={() => navigate('/login')}
            mr={4}
          >
            Login
          </Button>
          <Button
            colorScheme="green"
            size="lg"
            onClick={() => navigate('/signup')}
          >
            Sign Up
          </Button>
        </Box>
      </Stack>
    </Container>
  )
}

export default Home
